import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/finished";

export default function CheckoutFinishedView({
  goBack,
}: PropsView) {
  return (
    <div className="h-full">
      <Header
        title="Pagamento"
        hasLeftButton
        goBack={goBack}
      />
      <main className="z-10 p-2 w-full flex justify-center h-full text-black h-form">
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          <div className="flex items-center justify-center w-full flex-col flex-1">
            <img 
              src={"/icon-checked.png"}
              width={80}
              height={80}
              alt="ícone sucesso"
              className="mt-10"
            />
            <h2 className="text-3xl text-black mt-2 text-center">Sucesso!</h2>
            <h3 className="text-base text-center mt-3">Seu pagamento foi realizado.</h3>
          </div>
          <div className="flex items-center flex-col px-8">
            <button onClick={goBack} type="button" className="w-full h-[calc(60px)] rounded-lg border bg-transparent border-black text-black font-medium mt-10 mb-[calc(80px)]">Sair</button>
          </div>
        </article>
      </main>
    </div>
  );
}
